/**
 * Constants for NodeVisualizer component styling and layout
 * Centralized values to avoid magic numbers scattered across files
 */

// Z-index values for proper stacking order
export const Z_INDEX = {
  OVERLAY: 10000, // Full-screen overlay background
  CANVAS: 10001, // ReactFlow canvas in full-screen mode
  PANELS: 10002, // Floating panels (details/legend) above canvas
  CONTROLS: 10002, // Floating controls (zoom/center) above canvas
};

// Full-screen mode spacing
export const FULL_SCREEN_SPACING = {
  GAP_SIZE: 16, // Padding around canvas in pixels
  PANEL_PADDING: 15, // Internal padding of the panel in pixels
};

// Default translate extent padding for ReactFlow
export const DEFAULT_TRANSLATE_EXTENT_PADDING = {
  x: 150,
  y: 150,
  top: 50,
};

// Panel positioning offsets
export const PANEL_POSITIONING = {
  RIGHT_OFFSET: 15, // Right offset for normal mode panels
  TOP_OFFSET: 15, // Top offset for normal mode panels
  FULLSCREEN_RIGHT_OFFSET: 30, // Additional right offset in full-screen mode
  FULLSCREEN_TOP_BASE: 30, // Base top offset in full-screen mode
  FULLSCREEN_TOP_EXTRA: 48, // Extra top offset for spacing
  FULLSCREEN_TOP_ADDITIONAL: 20, // Additional top offset adjustment
};

// Default viewport settings for ReactFlow
export const DEFAULT_VIEWPORT = {
  ZOOM: 0.8, // Default zoom level
  Y_OFFSET: -30, // Vertical offset for better visual balance
  ANIMATION_DURATION: 500, // Animation duration in milliseconds
  LAYOUT_DELAY: 100, // Delay before applying layout in milliseconds
};

// Zoom limits for ReactFlow
export const ZOOM_LIMITS = {
  MIN: 0.3, // Minimum zoom (prevents zooming out beyond fit-to-screen view)
  MAX: 2, // Maximum zoom (prevents zooming in too close)
  FIT_VIEW_MAX: 1, // Maximum zoom when using fitView (strategy canvas)
  DYNAMIC_MIN_MAX: 1.0, // Maximum value for dynamically calculated minZoom (prevents too high zoom for small node counts)
  MIN_NODES_FOR_DYNAMIC: 5, // Minimum number of nodes before using dynamic minZoom calculation
};
